import { Injectable } from "@angular/core";
import { HttpErrorResponse, HttpEvent, HttpEventType, HttpProgressEvent } from "@angular/common/http";
import { empty, of, Subject } from "rxjs";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from "@ngrx/store";
import { validate as uuidValidate } from 'uuid';
import { State } from "..";
import { RappService } from "src/app/services/rapp-services.service";
import {
    ApplicationActionType, ClearSelectedProblemMenuItem, ClearSelectedProblemMenuItemSuccess,
    FilterProblemMenuItems, GetProblemMenuConfig, GetProblemMenuConfigError,
    SetProblemMenuConfigItems, ProblemMenuConfig,
    ProblemMenuItem,
    SetSelectedProblemMenuItemConfig, SetSelectedProblemMenuItemSuccess, SetUnmodifiableMenuConfig,
    SetFilterProblemMenuItemCount,
    CreateProblemStub, CreateProblemStubSuccess, ResetProblemMenuItems,
    RemovePhoto, SubmitProblem, SubmitProblemSuccess, GetProblemQuestionsError,
    QuestionsPayload, GetProblemQuestionsSuccess, QuestionAnswer, QuestionDependenceMapObj, GetProblemQuestions, SubmitPhoto,
    UpdatePhotoUploadStatus, ImageFile, ValidatePhotoUpload, SetCurrentStep, ProgressionStep, SaveProblemTypeSearchLog,
    JumpToSystemError, ConvertProblemQuestions, ConvertProblemQuestionsSuccess, NoAction, DelayedActionBy1s, QuestionTypes, QuestionConfirmationStatus, 
} from ".";
import { catchError, concatMap, debounceTime, delay, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';

import * as jQuery from "jquery";
import * as shajs from 'sha.js';
import * as Honeybadger from "@honeybadger-io/js";
import { environment } from "src/environments/environment";

declare const GOOGLE_RECAPTCHA_SITE_KEY: string;
declare const grecaptcha: any;
declare let CORRELATION_TOKEN: string;

@Injectable()
export class ApplicationEffects {

    filterTextExchangeMap: Map<string, string> = new Map([
        ['dangerous', 'unsafe'],
        ['missed', 'uncollected'],
        ['not collected', 'uncollected'],
        ['green bin', 'organics'],
        ['in-law', 'secondary'],
        ['car', 'vehicle'],
        ['truck', 'vehicle'],
        ['trash', 'garbage'],
        ['home', 'residential'],
        ['bark', 'nuisance'],
        ['barking', 'nuisance'],
        ['fish kill', 'pollution'],
        ['spill', 'pollution'],
        ['parking', 'parked'],
        ['dog', 'pet'],
        ['cat', 'pet']
    ]);

    getQuestionHeading(problemMenuConfig_RefId: number): string {
        let questionHeading = "";
        switch (problemMenuConfig_RefId) {
            case 1:
            case 2:
                questionHeading = "Provide animal details";
                break;

            case 3:
            case 5:
            case 6:
            case 254:
                questionHeading = "Provide pet details";
                break;

            case 4:
                questionHeading = "Provide dog details";
                break;

            case 33:
            case 34:
                questionHeading = "Provide vehicle details";
                break;

            default:
                break;
        }

        return questionHeading;
    }

    getProblemTypeMenu$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ApplicationActionType.GetProblemMenuConfig),
            switchMap((action: GetProblemMenuConfig) => {
                return this.rappService.getProblemMenuConfig().pipe(
                    switchMap((data: ProblemMenuConfig[]) => {

                        // generate the menuHead's for the top layer menu
                        let problemMenuItemArr: ProblemMenuItem[] = [];
                        data.forEach(menuItem => {
                            const menuOne = menuItem.MenuOne;
                            const menuOneExists = problemMenuItemArr.some(entry => entry.menuHead === menuOne);

                            if (!menuOneExists) {
                                problemMenuItemArr.push({
                                    menuHead: menuOne,
                                    subMenus: [],
                                    menuItem: null,
                                    shouldExpandDropdown: false,
                                    selected: false
                                });
                            }
                        });

                        // go through each menu entry and add to their appropriate
                        problemMenuItemArr.forEach(menuEntry => {
                            const menuItems = data.filter(menuItemEntry => menuItemEntry.MenuOne === menuEntry.menuHead);
                            menuItems.forEach(menuItem => {
                                const menuTwo = menuItem.MenuTwo;

                                // check if head menuItem has a sub catagory to select or not
                                if (menuTwo.length === 0) {
                                    menuEntry.menuItem = menuItem;

                                } else { // sub catagories are present
                                    const hasMenuTwoEntry = menuEntry.subMenus.some(entry => entry.menuHead === menuTwo);
                                    if (!hasMenuTwoEntry) {
                                        const menuThreeExists = menuItem.MenuThree.length > 0;

                                        if (!menuThreeExists) {
                                            menuEntry.subMenus.push({
                                                menuHead: menuTwo,
                                                subMenus: [],
                                                menuItem,
                                                shouldExpandDropdown: false,
                                                selected: false
                                            });
                                        } else {
                                            menuEntry.subMenus.push({
                                                menuHead: menuTwo,
                                                subMenus: [{
                                                    menuHead: menuItem.MenuThree,
                                                    subMenus: [],
                                                    menuItem: menuItem,
                                                    selected: false
                                                }],
                                                menuItem: null,
                                                shouldExpandDropdown: false,
                                                selected: false
                                            })
                                        }
                                    } else { // if it reaches this else block a menuThree entry also has to exist
                                        const subMenuIndex = menuEntry.subMenus.findIndex(entry => entry.menuHead === menuTwo);
                                        menuEntry.subMenus[subMenuIndex].subMenus.push({
                                            menuHead: menuItem.MenuThree,
                                            subMenus: [],
                                            menuItem,
                                            selected: false
                                        });
                                    }
                                }
                            });
                        });

                        problemMenuItemArr = problemMenuItemArr.sort((a, b) => (a.menuHead > b.menuHead) ? 1 : -1);
                        problemMenuItemArr.forEach(menuHead => {
                            menuHead.subMenus = menuHead.subMenus.sort((a, b) => (a.menuHead > b.menuHead) ? 1 : -1);
                            menuHead.subMenus.forEach(menuLevel2 => {
                                menuLevel2.subMenus.sort((a, b) => (a.menuHead > b.menuHead) ? 1 : -1);
                            })
                        });

                        // move other to the bottom of the list
                        problemMenuItemArr.forEach(menuLevel1 => {
                            let level2OtherIndex = menuLevel1.subMenus.findIndex(menuLevel2 => menuLevel2.menuHead === 'Other');
                            if (level2OtherIndex !== -1) {
                                menuLevel1.subMenus.push(menuLevel1.subMenus.splice(level2OtherIndex, 1)[0]);
                                menuLevel1.subMenus.forEach(menuLevel2 => {

                                    let level3OtherIndex = menuLevel2.subMenus.findIndex(menuLevel3 => menuLevel3.menuHead === 'Other');
                                    if (level3OtherIndex !== -1) {
                                        menuLevel2.subMenus.push(menuLevel2.subMenus.splice(level3OtherIndex, 1)[0]);
                                    }
                                });
                            }
                        })

                        return [
                            new SetProblemMenuConfigItems(problemMenuItemArr),
                            new SetUnmodifiableMenuConfig(problemMenuItemArr)
                        ];
                    }),
                    catchError((error: any) => {
                        Honeybadger.notify(error, {name: 'HttpErrorResponse', action: ApplicationActionType.GetProblemMenuConfig});

                        return [
                            new GetProblemMenuConfigError(error),
                            new JumpToSystemError(),
                        ];
                    })
                )
            })
        )
    );

    getProblemQuestions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ApplicationActionType.GetProblemQuestions),
            switchMap((action: GetProblemQuestions) => {
                return this.rappService.getProblemQuestions(action.payload!).pipe(
                    switchMap((questions: QuestionsPayload[]) => {
                        let questionAnswers: QuestionAnswer[] = [];
                        questions
                            .forEach(question => {
                                let newQuestionObj: QuestionAnswer = {
                                    problemMenuConfig_RefId: question.problemMenuConfig_RefId,
                                    questionNumber: question.questionNumber,
                                    questionType: question.questionType,
                                    question: question.question,
                                    answer: "",
                                    isRequired: question.isRequired,
                                    questionViewable: true,
                                    questionHeading: this.getQuestionHeading(question.problemMenuConfig_RefId),
                                    shouldDisplayNotFilledError: false
                                };

                                let options;
                                switch (question.questionType) {
                                    case QuestionTypes.RadioButton:
                                        options = question.options.split(',');
                                        newQuestionObj.radioOptions = options;

                                        if (options.includes("Other")) {
                                            newQuestionObj.radioOtherOptionEntry = "";
                                        }
                                        break;

                                    case QuestionTypes.SelectBox:
                                        options = question.options.split(',');
                                        newQuestionObj.selectOptions = options;
                                        break;

                                    case QuestionTypes.Checkbox:
                                        options = question.options.split(',');
                                        newQuestionObj.checkOptionAnswers = [];

                                        options.forEach(option => {
                                            newQuestionObj.checkOptionAnswers!.push({
                                                option,
                                                answer: false
                                            });
                                        });
                                        break;

                                    case QuestionTypes.ConfirmationToggle:
                                        let confirmationPrompt = question.options;
                                        newQuestionObj.confirmationTypeMsg = confirmationPrompt;
                                        newQuestionObj.confirmationStatus = QuestionConfirmationStatus.Unconfirmed;
                                        newQuestionObj.confirmationAnswer = false;
                                        break;

                                    default:
                                        break;
                                }

                                let needsDependencyMapping = question.dependsOnMap.length > 0;
                                if (needsDependencyMapping) {
                                    let dependencyMap: Map<number, string> = new Map();
                                    let dependsOnMap: QuestionDependenceMapObj[] = JSON.parse(question.dependsOnMap);
                                    dependsOnMap.forEach(dependency => {
                                        dependencyMap.set(Number(dependency.key), dependency.value);
                                    });

                                    newQuestionObj.dependsOnQuestionAnswer = dependencyMap;
                                    newQuestionObj.questionViewable = false;
                                }

                                let usesTooltip = !!question.tooltip && question.tooltip.length > 0;
                                if (usesTooltip) {
                                    newQuestionObj.tooltip = question.tooltip;
                                }

                                let hasYesConditionalMsg = !!question.conditionalYesMsg && question.conditionalYesMsg.length > 0;
                                let hasNoConditionalMsg = !!question.conditionalNoMsg && question.conditionalNoMsg.length > 0;

                                if (hasYesConditionalMsg) {
                                    newQuestionObj.conditionalYesMsg = question.conditionalYesMsg;
                                }

                                if (hasNoConditionalMsg) {
                                    newQuestionObj.conditionalNoMsg = question.conditionalNoMsg;
                                }

                                if (question.errorMsgText.length > 0) {
                                    newQuestionObj.errorMsgText = question.errorMsgText;
                                }

                                questionAnswers.push(newQuestionObj);
                            })
                            ;

                        return of(new GetProblemQuestionsSuccess(questionAnswers));
                    }),
                    catchError((error: any) => {
                        Honeybadger.notify(error, {name: 'HttpErrorResponse', action: ApplicationActionType.GetProblemQuestions});

                        // No need to jump to system error here I believe
                        return of(new GetProblemQuestionsError(error));
                    })
                );
            })
        )
    );

    convertToProblemQuestions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ApplicationActionType.ConvertProblemQuestions),
            switchMap((action: ConvertProblemQuestions) => {
                let questionAnswers: QuestionAnswer[] = [];
                action.payload!.forEach(question => {
                    let newQuestionObj: QuestionAnswer = {
                        problemMenuConfig_RefId: question.problemMenuConfig_RefId,
                        questionNumber: question.questionNumber,
                        questionType: question.questionType,
                        question: question.question,
                        answer: "",
                        isRequired: question.isRequired,
                        questionViewable: true
                    };

                    let options;
                    switch (question.questionType) {
                        case 'radio':
                            options = question.options.split(',');
                            newQuestionObj.radioOptions = options;
                            break;

                        case 'select':
                            options = question.options.split(',');
                            newQuestionObj.selectOptions = options;
                            break;

                        default:
                            break;
                    }

                    let needsDependencyMapping = question.dependsOnMap.length > 0;
                    if (needsDependencyMapping) {
                        let dependencyMap: Map<number, string> = new Map();
                        let dependsOnMap: QuestionDependenceMapObj[] = JSON.parse(question.dependsOnMap);
                        dependsOnMap.forEach(dependency => {
                            dependencyMap.set(Number(dependency.key), dependency.value);
                        });

                        newQuestionObj.dependsOnQuestionAnswer = dependencyMap;
                        newQuestionObj.questionViewable = false;
                    }

                    let usesTooltip = !!question.tooltip && question.tooltip.length > 0;
                    if (usesTooltip) {
                        newQuestionObj.tooltip = question.tooltip;
                    }

                    let hasYesConditionalMsg = !!question.conditionalYesMsg && question.conditionalYesMsg.length > 0;
                    let hasNoConditionalMsg = !!question.conditionalNoMsg && question.conditionalNoMsg.length > 0;

                    if (hasYesConditionalMsg) {
                        newQuestionObj.conditionalYesMsg = question.conditionalYesMsg;
                    }

                    if (hasNoConditionalMsg) {
                        newQuestionObj.conditionalNoMsg = question.conditionalNoMsg;
                    }

                    questionAnswers.push(newQuestionObj);
                });

                return of(new ConvertProblemQuestionsSuccess(questionAnswers));
            })
        )
    );

    resetProblemMenuItems$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ApplicationActionType.ResetProblemMenuItems),
            withLatestFrom(this.store$),
            switchMap(([action, store]: [ResetProblemMenuItems, State]) => {
                const problemMenuItems: ProblemMenuItem[] = jQuery.extend(true, [], store.applicationReducer.unModifiedMenuItems);
                const selectedMenuItem = store.applicationReducer.selectedProblemMenuItem;

                problemMenuItems.forEach(menuLevel1 => {
                    if (menuLevel1.subMenus.length) {
                        menuLevel1.subMenus.forEach(menuLevel2 => {
                            if (menuLevel2.subMenus.length) {
                                menuLevel2.subMenus.forEach(menuLevel3 => {
                                    if (menuLevel3.menuItem?.ProblemMenuConfig_RefId === selectedMenuItem.ProblemMenuConfig_RefId) {
                                        menuLevel3.selected = true;
                                    }
                                });

                            } else {
                                if (menuLevel2.menuItem?.ProblemMenuConfig_RefId === selectedMenuItem.ProblemMenuConfig_RefId) {
                                    menuLevel2.selected = true;
                                }
                            }

                        });
                    } else {
                        if (menuLevel1.menuItem?.ProblemMenuConfig_RefId === selectedMenuItem.ProblemMenuConfig_RefId) {
                            menuLevel1.selected = true;
                        }
                    }
                });

                return of(new SetProblemMenuConfigItems(problemMenuItems));
            })
        )
    );

    filterProblemMenuItems$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ApplicationActionType.FilterProblemMenuItems),
            withLatestFrom(this.store$),
            switchMap(([action, store]: [FilterProblemMenuItems, State]) => {
                const problemMenuItems: ProblemMenuItem[] = jQuery.extend(true, [], store.applicationReducer.unModifiedMenuItems);
                const filterString = action.payload?.toLowerCase() || "";

                if (filterString.length === 0) {
                    return of(new SetProblemMenuConfigItems(problemMenuItems));
                }

                let filteredProblemMenuItems: ProblemMenuItem[] = [];
                let filteredResultsCount: number = 0;

                let stringsToSearch: string[] = [filterString];

                const containsWord = (wordFragment: string, textToSearch: string) => {
                    const beginningOfWordMatch = new RegExp('\\b' + wordFragment, 'i');
                    return beginningOfWordMatch.test(textToSearch);
                }

                filterString.split(" ").forEach(text => {
                    if (text.length > 0) {
                        for (let [key, value] of this.filterTextExchangeMap) {
                            if (containsWord(text, key)) {
                                stringsToSearch.push(value.toLowerCase());
                            }
                        }
                    }
                });


                problemMenuItems.forEach(menuItem => {

                    // CASE: MenuHead level 1 has the filter substring
                    // if (stringsToSearch.some(searchString => menuItem.menuHead.toLowerCase().includes(searchString))) {
                    //     // all items underneath level 1 (level 2) need to be shown and counted towards the number of matches
                    //     if (menuItem.subMenus) {
                    //         menuItem.shouldExpandDropdown = true;
                    //         filteredResultsCount += menuItem.subMenus.length;

                    //         // go from menuLevelTwo and check the third level menuItems for whether or not a match exists and if so expand
                    //         menuItem.subMenus.forEach(menuLevelTwo => {
                    //             let existsInLevelThree = false;
                    //             menuLevelTwo.subMenus.forEach(menuLevelThree => {

                    //                 // if (menuLevelThree.menuHead.toLowerCase().includes(filterString)) {
                    //                 if (stringsToSearch.some(searchString => menuLevelThree.menuHead.toLowerCase().includes(searchString))) {
                    //                     existsInLevelThree = true;
                    //                 }
                    //             });

                    //             // set the level two menus that have a match in level 3 expand themselves and add to the counter
                    //             if (existsInLevelThree) {
                    //                 menuLevelTwo.shouldExpandDropdown = true;
                    //                 filteredResultsCount += menuLevelTwo.subMenus.length;

                    //                 // remove one from the counter as the menuLevelTwo is not the leaf node being displayed
                    //                 filteredResultsCount--;
                    //             }
                    //         });

                    //     } else {
                    //         // Level 1 has no submenus so increment counter by 1 only
                    //         filteredResultsCount++;
                    //     }

                    //     filteredProblemMenuItems.push(menuItem);
                    // }

                    // CASE: MenuHead level 1 does not have the filter substring
                    // need to build a menuItem from scratch depending on whether a child level menu matches the filter or not

                    // if (!menuItem.menuHead.toLowerCase().includes(filterString)) {
                    // if (!stringsToSearch.some(searchString => menuItem.menuHead.toLowerCase().includes(searchString))) {
                    let matchFound = false;

                    // make a new placeholder level one menuitem
                    let newMenuItemLevelOne: ProblemMenuItem = {
                        menuHead: menuItem.menuHead,
                        subMenus: [],
                        menuItem: menuItem.menuItem,
                        shouldExpandDropdown: false,
                        selected: false
                    };

                    if (stringsToSearch.some(searchString => containsWord(searchString, menuItem.menuHead)) && !menuItem.subMenus.length) {
                        matchFound = true;
                        filteredResultsCount++;
                    }

                    // check if any member in level two matches
                    if (menuItem.subMenus) {
                        menuItem.subMenus.forEach(menuLevelTwo => {

                            // check if any menuItem in level two matches the filter string and if so, build the new Menu item
                            // if (menuLevelTwo.menuHead.toLowerCase().includes(filterString)) {
                            if (stringsToSearch.some(searchString => containsWord(searchString, menuLevelTwo.menuHead))) {
                                filteredResultsCount++;
                                matchFound = true;

                                let newMenuItemLevelTwo: ProblemMenuItem = {
                                    menuHead: menuLevelTwo.menuHead,
                                    subMenus: menuLevelTwo.subMenus,
                                    menuItem: menuLevelTwo.menuItem,
                                    shouldExpandDropdown: false,
                                    selected: false
                                };

                                // check if any members in level three match the filter string
                                newMenuItemLevelTwo.subMenus.forEach(menuLevelThree => {
                                    // if a match exists, expand menu level two

                                    // if (menuLevelThree.menuHead.toLowerCase().includes(filterString)) {
                                    if (stringsToSearch.some(searchString => containsWord(searchString, menuLevelThree.menuHead))) {
                                        filteredResultsCount++;
                                        newMenuItemLevelTwo.shouldExpandDropdown = true;
                                    }
                                });

                                // need to remove a count here as menuLevelTwo is no longer the leaf node being displayed
                                // if (newMenuItemLevelTwo.shouldExpandDropdown) {
                                //     filteredResultsCount--;
                                // }

                                newMenuItemLevelOne.subMenus.push(newMenuItemLevelTwo);
                                newMenuItemLevelOne.shouldExpandDropdown = true;

                            } else {
                                let foundInLevelThree = false;

                                // check if any menuItem in level three matches the filter string and if so, build the new menuItem
                                let newMenuItemLevelTwo: ProblemMenuItem = {
                                    menuHead: menuLevelTwo.menuHead,
                                    subMenus: [],
                                    menuItem: menuLevelTwo.menuItem,
                                    shouldExpandDropdown: false,
                                    selected: false
                                };

                                menuLevelTwo.subMenus.forEach(menuLevelThree => {
                                    // if a match exists, add it to menu level two and expand it

                                    // if (menuLevelThree.menuHead.toLowerCase().includes(filterString)) {
                                    if (stringsToSearch.some(searchString => containsWord(searchString, menuLevelThree.menuHead))) {
                                        matchFound = true;
                                        foundInLevelThree = true;
                                        filteredResultsCount++;

                                        newMenuItemLevelTwo.subMenus.push(menuLevelThree);
                                        newMenuItemLevelTwo.shouldExpandDropdown = true;
                                    }
                                });

                                if (foundInLevelThree) {
                                    newMenuItemLevelOne.subMenus.push(newMenuItemLevelTwo);
                                    newMenuItemLevelOne.shouldExpandDropdown = true;

                                } else {
                                    let foundInLevelThree = false;

                                    // check if any menuItem in level three matches the filter string and if so, build the new menuItem
                                    let newMenuItemLevelTwo: ProblemMenuItem = {
                                        menuHead: menuLevelTwo.menuHead,
                                        subMenus: [],
                                        menuItem: menuLevelTwo.menuItem,
                                        shouldExpandDropdown: false,
                                        selected: false
                                    };

                                    menuLevelTwo.subMenus.forEach(menuLevelThree => {
                                        // if a match exists, add it to menu level two and expand it

                                        // if (menuLevelThree.menuHead.toLowerCase().includes(filterString)) {
                                        if (stringsToSearch.some(searchString => containsWord(searchString, menuLevelThree.menuHead))) {
                                            matchFound = true;
                                            foundInLevelThree = true;
                                            filteredResultsCount++;

                                            newMenuItemLevelTwo.subMenus.push(menuLevelThree);
                                            newMenuItemLevelTwo.shouldExpandDropdown = true;
                                        }
                                    });

                                    if (foundInLevelThree) {
                                        newMenuItemLevelOne.subMenus.push(newMenuItemLevelTwo);
                                        newMenuItemLevelOne.shouldExpandDropdown = true;
                                    }
                                }
                            }
                        });
                    }

                    if (matchFound) {
                        filteredProblemMenuItems.push(newMenuItemLevelOne);
                    }
                    // }

                });

                return [
                    new SetProblemMenuConfigItems(filteredProblemMenuItems),
                    new SetFilterProblemMenuItemCount(filteredResultsCount)
                ];
            })
        )
    );

    clearSelectedProblemMenuItem$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ApplicationActionType.ClearSelectedProblemMenuItem),
            withLatestFrom(this.store$),
            switchMap(([action, store]: [ClearSelectedProblemMenuItem, State]) => {
                const problemMenuItems: ProblemMenuItem[] = jQuery.extend(true, [], store.applicationReducer.newProblemMenuItems);
                problemMenuItems.forEach(menuLevelOne => {
                    menuLevelOne.selected = false;
                    menuLevelOne.shouldExpandDropdown = false;
                    menuLevelOne.subMenus.forEach(menuLevelTwo => {

                        menuLevelTwo.selected = false;
                        menuLevelTwo.shouldExpandDropdown = false;
                        menuLevelTwo.subMenus.forEach(menuLevelThree => menuLevelThree.selected = false);
                    });
                });

                return of(new ClearSelectedProblemMenuItemSuccess(problemMenuItems));
            })
        )
    );

    setSelectedProblemMenuItem$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ApplicationActionType.SetSelectedProblemMenuItemConfig),
            withLatestFrom(this.store$),
            switchMap(([action, store]: [SetSelectedProblemMenuItemConfig, State]) => {
                const problemMenuItems: ProblemMenuItem[] = jQuery.extend(true, [], store.applicationReducer.newProblemMenuItems);
                const menuItemSelected = action.payload!;

                // deselect all that don't match while leaving the one that does set to true
                problemMenuItems.forEach(menuLevelOne => {

                    // selected item is in this menu
                    if (menuLevelOne.menuHead === menuItemSelected.MenuOne) {

                        // located in a submenu
                        if (menuLevelOne.menuItem === null) {
                            menuLevelOne.selected = false;
                            menuLevelOne.shouldExpandDropdown = true;

                            menuLevelOne.subMenus.forEach(menuLevelTwo => {

                                if (menuLevelTwo.menuHead === menuItemSelected.MenuTwo) {

                                    // located in the third menu level
                                    if (menuLevelTwo.menuItem === null) {
                                        menuLevelTwo.selected = false;
                                        menuLevelTwo.shouldExpandDropdown = true;
                                        menuLevelTwo.subMenus.forEach(menuLevelThree => {

                                            if (menuLevelThree.menuItem!.MenuThree === menuItemSelected.MenuThree) {
                                                menuLevelThree.selected = true;
                                            } else {
                                                menuLevelThree.selected = false;
                                            }
                                        });
                                    } else {
                                        menuLevelTwo.selected = true;
                                    }
                                } else {
                                    menuLevelTwo.selected = false;

                                    if (menuLevelTwo.menuItem === null) {
                                        menuLevelTwo.shouldExpandDropdown = false;
                                    }

                                    menuLevelTwo.subMenus.forEach(menuLevelThree => {
                                        menuLevelThree.selected = false;
                                    });
                                }
                            });
                        } else {
                            menuLevelOne.selected = true;
                        }
                    } else {
                        // selected item is not in this menu so set all selected properties to false
                        menuLevelOne.selected = false;

                        if (menuLevelOne.menuItem === null) {
                            menuLevelOne.shouldExpandDropdown = false;
                        }

                        menuLevelOne.subMenus.forEach(menuLevelTwo => {
                            menuLevelTwo.selected = false;

                            if (menuLevelTwo.menuItem === null) {
                                menuLevelTwo.shouldExpandDropdown = false;
                            }

                            menuLevelTwo.subMenus.forEach(menuLevelThree => menuLevelThree.selected = false);
                        });
                    }
                });

                return of(new SetSelectedProblemMenuItemSuccess(problemMenuItems));
            })
        )
    );

    createProblemStub$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ApplicationActionType.CreateProblemStub),
            withLatestFrom<CreateProblemStub, Store<State>>(this.store$),
            switchMap(([action, store]: [CreateProblemStub, State]) => {

                return this.rappService.getReCaptchaToken('problem_stub').pipe(
                    switchMap((token: string) => {

                        return this.rappService.postProblemStub(store.applicationReducer, token, 'problem_stub').pipe(
                            switchMap((data: any) => {
                                const newProblemGuid = data.guid || '';
                                if (uuidValidate(newProblemGuid)) {
                                    return [new CreateProblemStubSuccess(newProblemGuid)];
                                } else {
                                    return [
                                        new JumpToSystemError(),
                                    ];
                                }
                            }),
                            catchError(error => {
                                Honeybadger.notify(error, {name: 'HttpErrorResponse', action: ApplicationActionType.CreateProblemStub});

                                return [
                                    new JumpToSystemError(),
                                ]
                            }),
                        );

                    }),
                    catchError(error => {
                        Honeybadger.notify(error, {name: 'HttpErrorResponse', action: ApplicationActionType.CreateProblemStub + 'getReCaptchaToken'});

                        return [
                            new JumpToSystemError(),
                        ];
                    }),
                );

            })
        )
    );


    submitPhoto$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ApplicationActionType.SubmitPhoto),
            withLatestFrom<SubmitPhoto, Store<State>>(this.store$),
            concatMap(([action, store]: [SubmitPhoto, State]) => {
                const photoList = [...store.applicationReducer.problemPhotos];
                const file = action.payload!.file;

                // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
                // To retrieve only the Base64 encoded string, first remove data:*/*;base64, from the result.

                const dataURL: string = action.payload!.event;
                const regExp = new RegExp('data:.*/.*;base64,', 'g');

                regExp.test(dataURL.slice(0, 64));

                const source: string = dataURL.slice(regExp.lastIndex);
                const hash = shajs('sha256').update(source).digest('hex');
                let newPhotoObj: ImageFile = { file, source, hash, dataURL, progress: 0, imageStatus: 'uploading' };
                if (photoList.findIndex(photo => photo.hash === hash) === -1) {

                    return [
                        new ValidatePhotoUpload(newPhotoObj)
                    ];
                }
                return [];

            })
        )
    );

    delayedActionBy1s$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ApplicationActionType.DelayedActionBy1s),
            delay(1000),
            mergeMap((action: DelayedActionBy1s) => {
                return action.payload!;
            })
        )
    );

    validatePhotoUpload$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ApplicationActionType.ValidatePhotoUpload),
            withLatestFrom(this.store$),
            concatMap(([action, store]: [ValidatePhotoUpload, State]) => {

                // add a check here to prevent the delayBy1s action from infintely firing if a system error occurs or if the person is a developer debugging
                if (store.applicationReducer.currentStep !== ProgressionStep.SystemError) {
                    if (!environment.isDev && !uuidValidate(store.applicationReducer.newProblemUniqueId)) {
                        return [
                            new DelayedActionBy1s([
                                new ValidatePhotoUpload(action.payload)
                            ])
                        ];
                    }

                    return this.rappService.getReCaptchaToken('add_photo').pipe(
                        concatMap((token: string) => {

                            return this.rappService.postAddPhoto(store.applicationReducer, token, 'add_photo', action.payload!).pipe(
                                concatMap((event: HttpEvent<any>) => {

                                    if (event.type === HttpEventType.UploadProgress) {
                                        console.log('UploadProgress', event);
                                        let progress = Math.round((event as HttpProgressEvent).loaded / ((event as HttpProgressEvent).total ?? 1) * 100);
                                        progress = Math.min(100, Math.max(0, progress));
                                        return [
                                            new UpdatePhotoUploadStatus({
                                                ...action.payload!,
                                                progress: progress,
                                                imageStatus: 'uploading'
                                            })
                                        ];
                                    } else if (event.type === HttpEventType.Response) {
                                        console.log('Response', event);
                                        if (event.ok) {
                                            return [
                                                new UpdatePhotoUploadStatus({
                                                    ...action.payload!,
                                                    progress: 100,
                                                    imageStatus: 'success'
                                                })
                                            ];
                                        } else {
                                            return [
                                                new UpdatePhotoUploadStatus({
                                                    ...action.payload!,
                                                    imageStatus: 'rejected'
                                                }),
                                            ]
                                        }
                                    } else {
                                        return [];
                                    }
                                }),
                                catchError(error => {
                                    Honeybadger.notify(error, {name: 'HttpErrorResponse', action: ApplicationActionType.ValidatePhotoUpload});

                                    return [
                                        new UpdatePhotoUploadStatus({
                                            ...action.payload!,
                                            imageStatus: 'rejected'
                                        }),
                                    ]
                                })
                            )
                        }),
                        catchError(error => {
                            Honeybadger.notify(error, {name: 'HttpErrorResponse', action: ApplicationActionType.ValidatePhotoUpload + 'getReCaptchaToken'});
    
                            return [
                                new UpdatePhotoUploadStatus({
                                    ...action.payload!,
                                    imageStatus: 'rejected'
                                }),
                            ];
                        }),
                    )
                } else {
                    return [];
                }
            })
        )

    );

    removePhoto$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ApplicationActionType.RemovePhoto),
            withLatestFrom(this.store$),
            concatMap(([action, store]: [Action, State]) => {

                return this.rappService.getReCaptchaToken('remove_photo').pipe(
                    concatMap((token: string) => {

                        return this.rappService.postRemovePhoto(store.applicationReducer, token, 'remove_photo', (action as RemovePhoto).payload).pipe(
                            concatMap((data: any) => {
                                return [];
                            }),
                            catchError(error => {
                                Honeybadger.notify(error, {name: 'HttpErrorResponse', action: ApplicationActionType.RemovePhoto});

                                return [];
                            }),
                        );

                    }),
                    catchError(error => {
                        Honeybadger.notify(error, {name: 'HttpErrorResponse', action: ApplicationActionType.RemovePhoto + 'getReCaptchaToken'});

                        return [];
                    }),
                );

            })
        ),
        { dispatch: false }
    );

    submitProblem$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ApplicationActionType.SubmitProblem),
            withLatestFrom(this.store$),
            switchMap(([action, store]: [SubmitProblem, State]) => {

                return this.rappService.getReCaptchaToken('submit_problem').pipe(
                    switchMap((token: string) => {

                        return this.rappService.postSubmitProblem(store.applicationReducer, token, 'submit_problem').pipe(
                            switchMap((data: any) => {
                                return [
                                    new SubmitProblemSuccess(data),
                                    new SetCurrentStep(ProgressionStep.SubmissionComplete)
                                ];
                            }),
                            catchError(error => {
                                Honeybadger.notify(error, {name: 'HttpErrorResponse', action: ApplicationActionType.SubmitProblem});
                                
                                return [
                                    new JumpToSystemError(),
                                ];
                            }),
                        );

                    }),
                    catchError(error => {
                        Honeybadger.notify(error, {name: 'HttpErrorResponse', action: ApplicationActionType.SubmitProblem + 'getReCaptchaToken'});

                        return [
                            new JumpToSystemError(),
                        ]
                    }),
                );

            })
        )
    );

    saveProblemTypeSearchLog$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ApplicationActionType.SaveProblemTypeSearchLog),
            debounceTime(1000),
            switchMap((action: SaveProblemTypeSearchLog) => {
                return this.rappService.getReCaptchaToken('save_search_log').pipe(

                    switchMap((token: string) => {
                        return this.rappService.postSaveSearchLog(token, 'save_search_log', action.payload!).pipe(
                            switchMap((data: any) => {
                                return [];
                            }),
                            catchError(error => {
                                Honeybadger.notify(error, {name: 'HttpErrorResponse', action: ApplicationActionType.SaveProblemTypeSearchLog});
        
                                return [];
                            }),
                        )
                    }),
                    catchError(error => {
                        Honeybadger.notify(error, {name: 'HttpErrorResponse', action: ApplicationActionType.SaveProblemTypeSearchLog + 'getReCaptchaToken'});

                        return [];
                    }),
                )
            })
        ),
        { dispatch: false }
    );

    resetState$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ApplicationActionType.ResetState),
            switchMap(() => {
                // re-call the action to reset the correlation token
                const action = 'client_loaded';
                grecaptcha.enterprise.execute(GOOGLE_RECAPTCHA_SITE_KEY, { action: action }).then(function (token: any) {
                    const payload = {
                        token: token,
                        action: action
                    };

                    fetch('/api/client_loaded', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(payload)
                    }).then(data => {
                        if (data.status === 200) {
                            data.json().then(body => {
                                CORRELATION_TOKEN = (body && body.guid) || CORRELATION_TOKEN;
                            });
                        }
                    });
                });

                return of(new NoAction());
            })
        )
    );

    jumpToSystemError$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ApplicationActionType.JumpToSystemError),
            switchMap(() => {
                if (environment.isDev) {
                    return [];
                }

                return of(new SetCurrentStep(ProgressionStep.SystemError));
            })
        )
    );

    constructor(private actions$: Actions, private store$: Store<State>, private rappService: RappService) { }
}
